import { render, staticRenderFns } from "./ContactsTags.vue?vue&type=template&id=f6f73c4c&scoped=true&"
import script from "./ContactsTags.vue?vue&type=script&lang=js&"
export * from "./ContactsTags.vue?vue&type=script&lang=js&"
import style0 from "./ContactsTags.vue?vue&type=style&index=0&id=f6f73c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f73c4c",
  null
  
)

export default component.exports